export default function FitTextDirective(module) {
    angular.module(module || 'app')
        .directive('fitText', fitText);

    var id = 0;
    fitText.$inject = ['$window', '$timeout'];
    function fitText($window, $timeout) {
        var directive = {
            restrict: 'A',
            scope: {
                container: '@?',
                minWidth: '=',
                maxWidth: '=',
                minSize: '=',
                maxSize: '=?',
                maxHeight: '=?'
            },
            link: link
        };
        return directive;
        function link($scope, $element) {
            $scope.id = id++;

            function sizeText() {
                $timeout(function () {
                    var container = $scope.container ? $element.closest($scope.container) : $element;
                    var currentSize = parseInt($element.css('font-size'));
                    $element.css({
                        fontSize: '',
                        width: ''
                    });
                    var containerWidth = container.width();
                    var elementWidth = $element.width();
                    if (containerWidth <= elementWidth) {
                        $scope.$maxSize = $scope.maxSize || parseInt($element.css('font-size'));
                        if (elementWidth > 0) {
                            var finalSize;
                            if ($scope.container) {
                                var size = containerWidth / elementWidth * $scope.$maxSize;
                                finalSize = Math.max(size, $scope.minSize);
                            }
                            else {
                                if (containerWidth <= $scope.minWidth) {
                                    finalSize = $scope.minSize;
                                }
                                else if (elementWidth <= $scope.maxWidth) {
                                    var widthDiff = $scope.maxWidth - $scope.minWidth;
                                    var sizeDiff = $scope.$maxSize - $scope.minSize;
                                    finalSize = sizeDiff * ((width - $scope.minWidth) / widthDiff) + $scope.minSize;
                                }
                                else {
                                    var newSize = $scope.maxSize * ($scope.maxWidth / elementWidth);
                                    finalSize = Math.max(newSize, $scope.minSize);
                                }
                            }
                            if ($scope.maxHeight && finalSize > $scope.minSize) {
                                var elementHeight = $element.height();
                                if (elementHeight > $scope.maxHeight) {
                                    newSize = $scope.maxSize * ($scope.maxHeight / elementHeight);
                                    finalSize = Math.max(newSize, $scope.minSize);
                                }
                            }
                            $element.css('font-size', finalSize);
                            if (finalSize !== currentSize) {
                                $scope.$emit('sizeChange.fitText', {
                                    size: finalSize
                                });
                            }
                        }
                    }
                });
            }
            sizeText();
            var win = angular.element($window)
                .on(`resize.fitText${id}`, sizeText);
            $scope.$on('carouselV2.ready', sizeText);
        }
    }
};